<script>
	import { postFormData } from "../helpers.js";
	import { successToast, failureToast } from '../components/toast.js';
	import { username, loadUserInfo } from '../stores/userInfo.js';
	import Navbar from "../components/Navbar.svelte";
	import Footer from "../components/Footer.svelte";

	loadUserInfo();

	let requestForm;
	let emailSent = false;
	let requestPending = false;

	// Sends a password-reset email to the logged-in user's address. The user
	// sets the new password on the /password-reset page linked in the email.
	function handleSendVerification() {
		requestPending = true;
		let res = postFormData('user/password-reset-request', requestForm);
		res.then(response => response.json())
		.then(ret_json => {
			requestPending = false;
			if (ret_json.status === 'success') {
				emailSent = true;
				successToast("Check your email for a verification link.");
			} else {
				failureToast("Could not send the verification email. Please try again.");
			}
		})
		.catch(() => {
			requestPending = false;
			failureToast("Could not send the verification email. Please try again.");
		});
	}
</script>

<main class=background>
	<Navbar/>
	<div class="lg:mx-64 md:mx-32 sm:mx-10 mx-2 pb-20">
		<div class="mx-auto mt-10">
			<div class="max-w-xl mx-auto p-16 rounded-md shadow-lg bg-white bg-opacity-50">
				<p class="text-2xl font-semibold text-blue-900 mb-8">Change Password</p>
				{#if emailSent}
					<p class="text-xl mb-8">
						A verification email is on its way. Click the link in the email to set your new password.
					</p>
				{:else}
					<p class="text-xl mb-8">
						To change your password, we'll send a verification email to the address on your account.
						Click the link in that email to set your new password.
					</p>
				{/if}
				<form method="POST" class="flex-col h-full relative box-border" bind:this={requestForm} on:submit|preventDefault={handleSendVerification}>
					<input name="username" class="hidden" bind:value={$username}/>
					<div class="flex flex-row justify-between">
						<a class="w-2/5 text-lg font-sans" href="/user-info-menu">
							<button type="button" class="px-5 pb-2 pt-1 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
								Back
							</button>
						</a>
						{#if !emailSent}
							<input type="submit"
								value={requestPending ? "Sending..." : ($username ? "Send Verification Email" : "Loading...")}
								disabled={requestPending || !$username}
								class="w-3/5 pb-2 pt-1 text-xl !px-0 rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm disabled:opacity-50 disabled:cursor-not-allowed">
						{/if}
					</div>
				</form>
			</div>
		</div>
		<Footer/>
	</div>
</main>

<style>
	main.background { 
		background-color:theme("colors.gray.100");
	}

</style>
